<template>
  <div class="flex overflow-scroll mt-4 pb-3">
    <div
      class="flex bg-white shadow px-2 py-1 rounded-lg flex-shrink-0 mx-2"
      v-for="(product, index) in products"
      :key="product"
      :class="{ 'border border-purple-400': index === this.activeProduct }"
      @click="this.activeProduct = index"
    >
      <BadgeCheckIcon
        class="h-6 w-6 ml-1 text-green-500"
        v-if="isProductAnswered(product)"
      />
      {{ product.name }}
    </div>
  </div>

  <Panel class="mt-4" name="ارزیابی رقبا">
    <div v-for="(product, productIndex) in products" :key="product">
      <div
        class="grid grid-cols-2 text-center"
        v-if="productIndex === this.activeProduct"
      >
        <div
          class="flex items-center text-sm py-4 px-1 bg-gray-100 shadow rounded-lg m-2"
          v-for="(brand, brandIndex) in product.brands"
          :key="brand"
          @click="selectBrand(brandIndex, brand.name)"
        >
          <BadgeCheckIcon
            class="h-6 w-6 ml-1 text-green-500"
            v-if="isBrandAnswered(brand)"
          />
          {{ brand.name }}
        </div>
      </div>
    </div>
  </Panel>

  <router-link to="/survey/details">
    <Button class="w-3/4 mt-5 mr-10" @click="submitCompetitorAnalyze"
      >ادامه</Button
    >
  </router-link>

  <!--  City Modal -->
  <transition name="fade">
    <div
      class="fixed flex justify-center w-full h-screen top-0 bg-gray-500 bg-opacity-60"
      v-if="questionModal"
      @click="questionModal = false"
    >
      <div
        class="bg-white shadow w-3/4 h-3/4 rounded-lg p-4 mt-10 overflow-scroll"
        @click.stop
      >
        <form action="" @submit.prevent="submitAnswers()">
          <input
            id="txtshelf"
            class="w-full p-2 my-2 rounded-lg bg-gray-100"
            placeholder="درصدسهم شلف"
            type="number"
            v-model="
              products[this.activeProduct].brands[this.activeBrand]
                .questions[20].score
            "
          />
          <div v-if="this.activeBrandName == 'تبرک'">
            <Select
              class="text-sm"
              v-for="(question, index) in arrayWithTabarok.filter(
                (brand) => brand.id !== 21
              )"
              :key="question.id"
              v-model="
                products[activeProduct].brands[activeBrand].questions[index]
                  .score
              "
            >
              <option value="" selected disabled>
                {{ question.question }}
              </option>
              <option value="0" v-if="question.id !== 20">خوب</option>
              <option value="1" v-if="question.id !== 20">متوسط</option>
              <option value="2" v-if="question.id !== 20">ضعیف</option>
              <option value="3" v-if="question.id !== 20">ندارد</option>
              <option value="0" v-if="question.id == 20">بیلبورد</option>
              <option value="1" v-if="question.id == 20">استرابورد</option>
              <option value="2" v-if="question.id == 20">تابلوسردرب</option>
              <option value="3" v-if="question.id == 20">لایت باکس</option>
              <option value="4" v-if="question.id == 20">استند/بنر/مش</option>
              <option value="5" v-if="question.id == 20">اجاره شلف</option>
              <option value="6" v-if="question.id == 20">اجاره باکس</option>
              <option value="7" v-if="question.id == 20">تلویزیون</option>
            </Select>
          </div>
          <div v-else>
            <Select
              class="text-sm"
              v-for="(question, index) in brandQuestions.filter(
                (brand) => brand.id !== 21
              )"
              :key="question.id"
              v-model="
                products[activeProduct].brands[activeBrand].questions[index]
                  .score
              "
            >
              <option value="" selected disabled>
                {{ question.question }}
              </option>
              <option value="0" v-if="question.id !== 20">خوب</option>
              <option value="1" v-if="question.id !== 20">متوسط</option>
              <option value="2" v-if="question.id !== 20">ضعیف</option>
              <option value="3" v-if="question.id !== 20">ندارد</option>
              <option value="0" v-if="question.id == 20">بیلبورد</option>
              <option value="1" v-if="question.id == 20">استرابورد</option>
              <option value="2" v-if="question.id == 20">تابلوسردرب</option>
              <option value="3" v-if="question.id == 20">لایت باکس</option>
              <option value="4" v-if="question.id == 20">استند/بنر/مش</option>
              <option value="5" v-if="question.id == 20">اجاره شلف</option>
              <option value="6" v-if="question.id == 20">اجاره باکس</option>
              <option value="7" v-if="question.id == 20">تلویزیون</option>
            </Select>
          </div>
          <Button class="w-full mt-5" type="submit">ثبت</Button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import Panel from "../../components/Panel";
import products from "../../data/products";
import Button from "../../components/Button";
import brandQuestions from "../../data/brandQuestions";
import Select from "../../components/Select";
import { BadgeCheckIcon } from "@heroicons/vue/outline";

export default {
  name: "CompetitorAnalyze",
  components: { Select, Button, Panel, BadgeCheckIcon },
  data() {
    return {
      products:
        this.$store.state.survey.competitorAnalyze.length > 0
          ? this.$store.state.survey.competitorAnalyze
          : products,
      activeProduct: 0,
      activeBrand: "",
      activeBrandName: "",
      arrayWithTabarok: [],
      questionModal: false,
      brandQuestions: brandQuestions,
      shelf: null,
    };
  },
  created() {
    if (this.$store.state.survey.competitorAnalyze.length === 0) {
      this.products.forEach((product) => {
        product.brands.forEach((brand) => {
          // only way to disable reactivity so that brand.questions isn't link to brandQuestions
          brand.questions = JSON.parse(JSON.stringify(this.brandQuestions));
        });
      });
    }
    let newArray = [1, 5, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
    this.arrayWithTabarok = brandQuestions.filter((u) =>
      newArray.includes(u.id)
    );
    console.log(this.arrayWithTabarok);
  },
  methods: {
    selectBrand(brandIndex, branName) {
      this.activeBrand = brandIndex;
      this.activeBrandName = branName;
      this.questionModal = true;
      this.shelf = null;
    },
    submitAnswers() {
      let value = document.getElementById("txtshelf").value;
      if (value != null) {
        products[this.activeProduct].brands[this.activeBrand].questions[20].score = document.getElementById("txtshelf").value.toString();

        // if (typeof value == "string" || value instanceof String)
        //   products[this.activeProduct].brands[
        //     this.activeBrand
        //   ].questions[20].score = document.getElementById("txtshelf").value;
        // else
        //   products[this.activeProduct].brands[
        //     this.activeBrand
        //   ].questions[20].score = document
        //     .getElementById("txtshelf")
        //     .value.toString();
      } else
        products[this.activeProduct].brands[
          this.activeBrand
        ].questions[20].score = null;
      this.questionModal = false;
      // this.products[this.activeProduct].brands[this.activeBrand].questions = this.brandQuestions
      // this.brandQuestions = require('../../data/brandQuestions').default
      // console.log(this.brandQuestions)
    },
    submitCompetitorAnalyze() {
      this.$store.dispatch("setCompetitorAnalyze", this.products);
    },
    isBrandAnswered(brand) {
      let result = false;
      brand.questions.forEach((question) => {
        if (question.score !== "") {
          result = true;
        }
      });

      return result;
    },
    isProductAnswered(product) {
      let result = false;
      product.brands.forEach((brand) => {
        if (this.isBrandAnswered(brand)) {
          result = true;
        }
      });

      return result;
    },
  },
};
</script>

<style scoped></style>
